import { useQuery } from "@tanstack/react-query";
import { fetchRegistryPackagings, type RegistryPackaging } from "@/integrations/agreements/client";
import { useAuthContext } from "@/components/AuthProvider";

/**
 * Catálogo de acondicionamentos do musa-agreements. O nome do hook ficou do tempo em que a
 * lista vinha por um gateway GraphQL; os consumidores não mudaram.
 *
 * `enabled: false` evita a busca em tela que não mostra o filtro.
 */
export function useGatewayPackagings(options: { enabled?: boolean } = {}) {
  const { profile } = useAuthContext();

  return useQuery<RegistryPackaging[]>({
    queryKey: ["registry-packagings"],
    queryFn: fetchRegistryPackagings,
    enabled: !!profile && (options.enabled ?? true),
    staleTime: 5 * 60 * 1000,
  });
}
